import createAuth0Client from "@auth0/auth0-spa-js";
import { writable } from "svelte/store";
import getAuthConfig from "../config/auth.config";
class AuthService {
    constructor() {
        this.auth0 = null;
    }
    async isAuthenticated() {
        await this.ensureAuth0();
        const isAuthenticated = await this.auth0.isAuthenticated();
        isAuth.set(isAuthenticated);
        return isAuthenticated;
    }
    async login() {
        await this.ensureAuth0();
        await this.auth0.loginWithRedirect({
            scope: 'openid profile email',
            redirect_uri: window.location.origin
        });
    }
    async me() {
        await this.ensureAuth0();
        isAuth.set(await this.auth0.isAuthenticated());
        return this.auth0.getUser();
    }
    async handlePossibleLogin() {
        await this.ensureAuth0();
        const isAuthenticated = await this.auth0.isAuthenticated();
        isAuth.set(isAuthenticated);
        if (isAuthenticated) {
            return;
        }
        // NEW - check for the code and state parameters
        const query = window.location.search;
        if (query.includes("code=") && query.includes("state=")) {
            // Process the login state
            await this.auth0.handleRedirectCallback();
            window.history.replaceState({}, document.title, "/");
            const isAuthenticated = await this.auth0.isAuthenticated();
            isAuth.set(isAuthenticated);
        }
    }
    async handleRedirectCallback() {
        await this.ensureAuth0();
        await this.auth0.handleRedirectCallback();
    }
    async logout() {
        await this.ensureAuth0();
        await this.auth0.logout();
        isAuth.set(false);
    }
    async ensureAuth0() {
        if (!this.auth0) {
            const config = getAuthConfig();
            this.auth0 = await createAuth0Client({
                domain: config.domain,
                client_id: config.clientId,
                cacheLocation: 'localstorage'
            });
        }
    }
}
export const authService = new AuthService();
export const isAuth = writable(false);
export const myProfile = writable(null);
isAuth.subscribe(async (x) => {
    if (x) {
        const me = await authService.me();
        myProfile.set(me);
    }
});
